import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import avatar1 from "../assets/kangaroo/KEF Icon.png";

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const name = user?.fullName || "Admin";
  const role = user?.user?.roles?.[0] || "User";

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    localStorage.removeItem("cartOrders");
    navigate("/");
  };

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}>
      {/* Toggle */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "4px 8px",
          borderRadius: "8px",
        }}
      >
        <img
          src={avatar1}
          alt="avatar"
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            objectFit: "cover",
            border: "2px solid #e9ecef",
          }}
        />
        {/* <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
            lineHeight: 1,
          }}
        >
          <span
            style={{
              fontSize: "13px",
              fontWeight: 500,
              color: "#212529",
              whiteSpace: "nowrap",
            }}
          >
            {name}
          </span>
          <small
            style={{
              fontSize: "11px",
              color: "#6c757d",
              marginTop: "2px",
              textTransform: "capitalize",
            }}
          >
            {role}
          </small>
        </div> */}
        <span
          style={{
            fontSize: "10px",
            color: "#adb5bd",
            marginLeft: "2px",
            display: "inline-block",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        >
          ▾
        </span>
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: "70px",
            right: "16px",
            width: "210px",
            backgroundColor: "#ffffff",
            border: "1px solid rgba(0,0,0,0.1)",
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            zIndex: 99999,
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{ padding: "10px 12px", borderBottom: "1px solid #e9ecef" }}
          >
            <div
              style={{
                fontSize: "10px",
                color: "#adb5bd",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
                fontWeight: 500,
              }}
            >
              Signed in as
            </div>
            <div
              style={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#212529",
                marginTop: "2px",
              }}
            >
              {name}
            </div>
          </div>

          {/* Items */}
          <div style={{ padding: "4px" }}>
            {/* <button onClick={() => { navigate("/profile"); setIsOpen(false); }} style={itemStyle}>
              <i className="mdi mdi-account-circle" style={iconStyle} />
              My profile
            </button> */}

            <button
              onClick={() => {
                navigate("/change-password");
                setIsOpen(false);
              }}
              style={itemStyle}
            >
              <i className="mdi mdi-lock-reset" style={iconStyle} />
              Change password
            </button>
            {/* <button
              onClick={() => {
                navigate("/user-profile");
                setIsOpen(false);
              }}
              style={itemStyle}
            >
              <i className="mdi mdi-lock-reset" style={iconStyle} />
              User Profile
            </button> */}

            {/* <div
              style={{ height: "1px", background: "#e9ecef", margin: "4px 0" }}
            /> */}

            {/* <button
              onClick={handleLogout}
              style={{ ...itemStyle, color: "#c0392b" }}
            >
              <i
                className="mdi mdi-logout"
                style={{ ...iconStyle, opacity: 0.75 }}
              />
              Logout
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
};

const itemStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  width: "100%",
  padding: "7px 8px",
  fontSize: "13px",
  color: "#495057",
  background: "none",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  textAlign: "left",
};

const iconStyle = {
  fontSize: "15px",
  opacity: 0.5,
  flexShrink: 0,
};

export default ProfileDropdown;
